import InputCron from './InputCron.vue'
InputCron.name = 'EsmEasyCron'
export default InputCron
